export default __webpack_public_path__ + "static/media/livingRoom.40990f75.jpg";